import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { findDOMNode } from 'react-dom';
import TagNew from '../tag/tag-new.jsx';
import './tag-view-panel.scss';

const TagViewPanelNew = ({ tags }) => {
    const [showPanel, setShowPanel] = useState(false);
    const [dropup, setDropup] = useState(false);
    const nodeRef = useRef();

    useEffect(() => {
        determineDropUp();
        window.addEventListener('resize', determineDropUp);
        window.addEventListener('scroll', determineDropUp);
    }, [])

    const determineDropUp = () => {
        const node = findDOMNode(nodeRef.current);
        if (!node) return;

        const nodeBottom = node.getBoundingClientRect().bottom;
        const distBottom = window.innerHeight - nodeBottom;
        setDropup(distBottom < 200);
    }

    const onMouseEnter = () => setShowPanel(true);
    const onMouseLeave = () => setShowPanel(false);

    return (
        <div ref={nodeRef}>
            {/* TAG IMAGE AND COUNT */}
            <div className="tag-count-container" onMouseEnter={tags && onMouseEnter} onMouseLeave={tags && onMouseLeave}>
                <Button className={`tag-icon-btn ${tags ? '' : 'no-tags-btn'}`} />
                <span className={`tag-count ${tags ? '' : 'no-tags-btn'}`}> {tags ? tags.length : 0} </span>
            </div>
            {/* LIST OF TAGS */}
            {   showPanel && dropup ?
                    <div className="tag-view-container-outer" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                        <div className={"tag-view-container tag-view-container-up"}>
                            <span className="tag-title">
                                Tags
                            </span>
                            <div className="tag-list-container">
                                {   tags && tags.map((tag) => {
                                    const key = `${tag}-${Math.random().toString(36).substring(7)}`;
                                    return (
                                        <div className="tag-list" key={key}>
                                            <TagNew label={tag} />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="tag-view-arrow-up" />
                    </div>
                :
                    showPanel &&
                    <div className="tag-view-container-outer" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                        <div className="tag-view-arrow" />
                        <div className={"tag-view-container"}>
                            <span className="tag-title">
                                Tags
                            </span>
                            {   tags && tags.map((tag) => {
                                const key = `${tag}-${Math.random().toString(36).substring(7)}`;
                                return (
                                    <div className="tag-list" key={key}>
                                        <TagNew label={tag} />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
            }
        </div>
    )
}

TagViewPanelNew.propTypes = {
    tags: PropTypes.arrayOf(PropTypes.string)
};

export default TagViewPanelNew;
